<template>
  <div>
    <b-card-actions
      ref="cardAction"
      title="Filters"
      @refresh="resetColFilters"
      @remove="resetColFilters"
    >
      <b-row>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Select Status</label>
          <v-select
            v-model="statusFilter"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="filterStatuOption"
            class="w-100"
            placeholder="Select Status"
            :reduce="(val) => val.value"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Amount</label>
          <b-form-input
            id="amount"
            v-model="amount"
            placeholder="amount"
          />
        </b-col>
        <b-col
          cols="12"
          md="1"
          class="mb-md-0 mb-2 mt-2"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="primary"
            class="btn-icon"
            @click="handleSearch"
          >Search
            <feather-icon icon="SearchIcon" />
          </b-button>
        </b-col>
      </b-row>
    </b-card-actions>
    <b-card no-body>
      <b-card-header class="pb-50">
        <h4>Credit Report</h4>
      </b-card-header>
      <b-table-simple
        :per-page="perPage"
        hover
        striped
        bordered
        responsive
        class="rounded-bottom mb-0"
      >
        <b-thead head-variant="light">
          <b-tr>
            <b-th>Login ID</b-th>
            <b-th>Amount</b-th>
            <b-th>Bank</b-th>
            <b-th>Date</b-th>
            <b-th>time</b-th>
            <b-th>Status</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-show="showLoading"
            class="b-table-busy-slot"
          >
            <b-td colspan="11">
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle" />
                <strong>Loading...</strong>
              </div>
            </b-td>
          </b-tr>
          <template v-if="list.length > 0 && !showLoading">
            <b-tr
              v-for="(tr, indextr) in list"
              :key="indextr"
            >
              <b-td>{{ tr.loginid }}</b-td>
              <b-td>{{ tr.amount }}</b-td>
              <b-td>{{ tr.bank_name }}</b-td>
              <b-td>{{ tr.date }}</b-td>
              <b-td>{{ tr.time }}</b-td>
              <b-td>
                {{ tr.payment_value==0?"Pending":(tr.payment_value==1?"Accepted":"Reject") }}
              </b-td>
            </b-tr>
          </template>
          <template v-else-if="!showLoading">
            <b-tr rowspan="10">
              <b-td
                colspan="11"
                class="text-center"
              >
                No data avilable
              </b-td>
            </b-tr>
          </template>
        </b-tbody>
      </b-table-simple>
      <b-card-body>
        <b-pagination
          v-if="totalRows > 0"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          size="sm"
          @change="handleChangePage"
        />
      </b-card-body>
    </b-card>
    <b-modal
      id="banke-deposit"
      modal-class="modal-success"
      centered
      title="File"
    >
      <b-img
        :src="icon"
        fluid
        class="w-100')"
      />
    </b-modal>
  </div>
</template>
<script>
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import {
  BTableSimple,
  BCard,
  BCardHeader,
  BCardBody,
  BThead,
  BTr,
  BTh,
  BTd,
  BTbody,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BImg,
  BModal,
  BPagination,
  VBTooltip,
  BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ReportService from '../../services/user.report.service'
import 'animate.css'

export default {
  components: {
    BTableSimple,
    BCard,
    BImg,
    BCardHeader,
    BCardBody,
    BThead,
    BTr,
    BTh,
    BTd,
    BTbody,
    vSelect,
    BRow,
    BCol,
    BModal,
    BButton,
    BFormInput,
    BPagination,
    BSpinner,
    BCardActions,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      perPage: 25,
      totalRows: '',
      currentPage: 1,
      from: 1,
      showLoading: false,
      data: [],
      amount: '',
      loginid: '',
      statusFilter: '',
      filterStatuOption: [
        { label: 'Pending', value: 'pending' },
        { label: 'Accepted', value: 1 },
        { label: 'Rejected', value: 2 },
      ],
    }
  },
  computed: {
    list() {
      return this.data
    },
  },
  mounted() {
    this.getBankDepositInfo()
  },
  methods: {
    handleSearch() {
      this.getBankDepositInfo({
        status: this.statusFilter,
        amount: this.amount,
      })
    },
    resetColFilters() {
      this.statusFilter = ''
      this.amount = ''
      this.getBankDepositInfo()
      this.$refs.cardAction.showLoading = false
    },
    getBankDepositInfo(data) {
      this.showLoading = true
      ReportService.getBankDeposit(data).then(
        response => {
          this.data = response.data
          this.totalRows = response.total
          this.from = response.from

          this.showLoading = false
        },
        () => {
          this.showLoading = false
        },
      )
    },
    handleChangePage(value) {
      this.getBankDepositInfo({
        page: value,
        status: this.statusFilter,
        amount: this.amount,
      })
    },
  },
}
</script>
